import React, { Component } from "react";
import AudioStyledComponent from "./AudioStyledComponent";
import { getServerEndpoint } from "utils/serverEndpoint";
import { fetchStaticResource } from "../../../../utils/utils";
class AudioArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioPaths: [],
    };
  }

  async componentDidMount() {
    if (this.props.audio && this.props.audio.length > 0) {
      await this.loadAudio();
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.audio !== this.props.audio) {
      await this.loadAudio();
    }
  }

  async loadAudio() {
    try {
      const audioPaths = await Promise.all(
        this.props.audio.map(async (voice) => {
          if (voice.voiceName) {
            let path = getServerEndpoint() + "audio/" + voice.voiceName;
            const fetchedAudioPath = await fetchStaticResource(path);
            return { voiceName: voice.voiceName, path: fetchedAudioPath };
          }
          return null;
        })
      );

      // Remove null values and update state
      this.setState({ audioPaths: audioPaths.filter(Boolean) });
    } catch (error) {
      console.error("Error loading audio:", error);
    }
  }

  render() {
    return (
      <div style={{ display: "inline-block" }}>
        {this.state.audioPaths.map(({ voiceName, path }) => (
          <AudioStyledComponent key={voiceName} voice={voiceName} paths={path} />
        ))}
      </div>
    );
  }
}


export default AudioArea;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetail/AudioComponent/AudioArea.jsx